<template>
  <div class="batch-student-upload">
    <h2>批量上传学生作业</h2>
         <div class="info-section" v-if="homeworkInfo && homeworkInfo.id">
       <div class="homework-info">
         <div class="homework-header">
           <i class="el-icon-document"></i>
           <h3>作业信息</h3>
         </div>
         <el-card class="homework-card" shadow="hover">
           <div class="homework-content">
             <div class="homework-name">
               <span class="label">作业名称：</span>
               <span class="value">{{ homeworkInfo.name }}</span>
             </div>
             <div class="homework-id">
               <span class="label">作业ID：</span>
               <el-tag type="info" size="small">{{ homeworkInfo.id }}</el-tag>
             </div>
           </div>
         </el-card>
       </div>
     </div>

    <el-divider content-position="center">学生作业批量上传</el-divider>

    <el-tabs v-model="activeTab" type="card">
      <el-tab-pane label="单张图片上传" name="single">
        <div class="upload-section">
          <div class="student-select">
            <h4>选择学生</h4>
            <el-select v-model="selectedStudent" placeholder="请选择学生" style="width: 100%;">
              <el-option
                v-for="student in studentList"
                :key="student.id"
                :label="student.username"
                :value="student.id">
              </el-option>
            </el-select>
          </div>

          <div class="image-upload">
            <h4>上传图片</h4>
            <el-upload
              class="upload-demo"
              drag
              action="#"
              :auto-upload="false"
              :on-change="handleFileChange"
              :on-remove="handleFileRemove"
              :file-list="fileList"
              :limit="1">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
            </el-upload>
          </div>

          <div class="upload-actions">
            <el-button type="primary" @click="submitSingleUpload" :disabled="!canSubmitSingle" :loading="uploading">上传</el-button>
            <el-button @click="resetSingleUpload">重置</el-button>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="批量上传" name="batch">
        <div class="batch-upload-section">
          <div class="batch-info">
            <el-alert
              title="批量上传说明"
              type="info"
              description="支持批量上传多个图片文件，系统将直接上传所有文件"
              show-icon
              :closable="false">
            </el-alert>
          </div>

                     <div class="batch-image-upload">
             <h4>批量上传图片</h4>
             <el-upload
               class="upload-demo"
               drag
               action="#"
               :auto-upload="false"
               :on-change="handleBatchFileChange"
               :on-remove="handleBatchFileRemove"
               :file-list="batchFileList"
               multiple
               :limit="20">
               <i class="el-icon-upload"></i>
               <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
               <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
             </el-upload>

           </div>

          <div class="upload-actions">
            <el-button type="primary" @click="submitBatchUpload" :disabled="!canSubmitBatch" :loading="uploading">批量上传</el-button>
            <el-button @click="resetBatchUpload">重置</el-button>
          </div>
        </div>
      </el-tab-pane>

      <!-- 暂时注释掉文件夹/压缩包上传功能 -->
      <!--
      <el-tab-pane label="文件夹/压缩包上传" name="folder">
        <div class="folder-upload-section">
          <div class="folder-info">
            <el-alert
              title="文件夹/压缩包上传说明"
              type="info"
              description="1. 支持上传整个文件夹或ZIP压缩包
                          2. 请确保每个文件名与对应学生名称匹配（例如：student1.jpg）
                          3. 系统将自动解析并匹配所有图片文件"
              show-icon
              :closable="false">
            </el-alert>
          </div>

          <div class="upload-type-selector">
            <h4>选择上传方式</h4>
            <el-radio-group v-model="folderUploadType">
              <el-radio :label="'folder'">文件夹上传</el-radio>
              <el-radio :label="'zip'">ZIP压缩包上传</el-radio>
            </el-radio-group>
          </div>

          <div v-if="folderUploadType === 'folder'" class="folder-upload">
            <h4>上传文件夹</h4>
            <div class="folder-upload-box" @click="triggerFolderInput">
              <input
                type="file"
                ref="folderInput"
                style="display: none"
                webkitdirectory
                directory
                multiple
                @change="handleFolderSelect"
              />
              <i class="el-icon-folder-opened"></i>
              <div class="upload-text">点击选择文件夹</div>
            </div>
            <div v-if="selectedFolderName" class="selected-folder">
              已选择文件夹: {{ selectedFolderName }} ({{ folderFileCount }}个文件)
            </div>
          </div>

          <div v-if="folderUploadType === 'zip'" class="zip-upload">
            <h4>上传ZIP压缩包</h4>
            <el-upload
              class="upload-demo"
              drag
              action="#"
              :auto-upload="false"
              :on-change="handleZipChange"
              :on-remove="handleZipRemove"
              :file-list="zipFileList"
              :limit="1"
              accept=".zip">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将ZIP文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传ZIP压缩文件</div>
            </el-upload>
          </div>

          <div class="folder-preview" v-if="folderFiles.length > 0">
            <h4>文件预览 (共{{ folderFiles.length }}个文件)</h4>
            <el-table :data="folderPreviewList" border style="width: 100%">
              <el-table-column prop="fileName" label="文件名" width="180"></el-table-column>
              <el-table-column prop="studentName" label="匹配学生">
                <template slot-scope="scope">
                  <template v-if="scope.row.status === 'matched'">
                    {{ scope.row.studentName }}
                  </template>
                  <el-select
                    v-else
                    v-model="scope.row.studentId"
                    placeholder="请手动匹配学生"
                    @change="handleManualMatch(scope.row)"
                    size="small"
                    style="width: 100%;">
                    <el-option
                      v-for="student in studentList"
                      :key="student.id"
                      :label="student.username"
                      :value="student.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="120">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.status === 'matched' ? 'success' : 'danger'">
                    {{ scope.row.status === 'matched' ? (scope.row.autoMatched ? '自动匹配' : '手动匹配') : '未匹配' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status === 'matched'"
                    type="text"
                    @click="cancelMatch(scope.row)">
                    取消匹配
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="folder-stats">
              <div>已匹配: {{ matchedCount }} 个文件</div>
              <div>未匹配: {{ unmatchedCount }} 个文件</div>
            </div>

            <div class="batch-manual-match" v-if="unmatchedCount > 0">
              <el-divider content-position="center">批量手动匹配</el-divider>
              <div class="batch-match-tools">
                <el-alert
                  title="批量匹配提示"
                  type="info"
                  description="您可以使用下面的工具批量处理未匹配的文件"
                  show-icon
                  :closable="false">
                </el-alert>

                <div class="match-by-pattern">
                  <h4>按文件名模式匹配</h4>
                  <el-form :inline="true" class="match-form">
                    <el-form-item label="文件名包含">
                      <el-input v-model="patternMatch.pattern" placeholder="如：student"></el-input>
                    </el-form-item>
                    <el-form-item label="匹配给学生">
                      <el-select v-model="patternMatch.studentId" placeholder="请选择学生">
                        <el-option
                          v-for="student in studentList"
                          :key="student.id"
                          :label="student.username"
                          :value="student.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="matchByPattern" :disabled="!canMatchByPattern">应用</el-button>
                    </el-form-item>
                  </el-form>
                </div>

                <div class="match-by-sequence">
                  <h4>按顺序批量匹配</h4>
                  <p>将未匹配的文件按顺序匹配给选定的学生列表</p>
                  <el-form :inline="true" class="match-form">
                    <el-form-item label="选择学生列表">
                      <el-select
                        v-model="sequenceMatch.studentIds"
                        multiple
                        placeholder="请选择多个学生"
                        style="min-width: 300px;">
                        <el-option
                          v-for="student in studentList"
                          :key="student.id"
                          :label="student.username"
                          :value="student.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="matchBySequence" :disabled="!canMatchBySequence">应用</el-button>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>

          <div class="upload-actions">
            <el-button type="primary" @click="submitFolderUpload" :disabled="!canSubmitFolder" :loading="uploading">开始上传</el-button>
            <el-button @click="resetFolderUpload">重置</el-button>
          </div>
        </div>
      </el-tab-pane>
      -->
    </el-tabs>

    <div class="upload-history" v-if="uploadHistory.length > 0">
      <el-divider content-position="center">上传历史</el-divider>
      <el-table :data="uploadHistory" border style="width: 100%">
        <el-table-column prop="studentName" label="学生姓名" width="120"></el-table-column>
        <el-table-column prop="fileName" label="文件名" width="150"></el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="150"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'success' ? 'success' : 'danger'">
              {{ scope.row.status === 'success' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="批改结果" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.judgeResult">
              <el-button type="text" @click="viewJudgeResult(scope.row)">查看结果</el-button>
            </div>
            <div v-else-if="scope.row.errorMessage">
              <el-tooltip :content="scope.row.errorMessage" placement="top">
                <span style="color: #f56c6c;">{{ scope.row.errorMessage }}</span>
              </el-tooltip>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="previewImage(scope.row)">预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog title="图片预览" :visible.sync="previewDialogVisible" width="50%">
      <div class="image-preview-container">
        <img v-if="previewImageUrl" :src="previewImageUrl" class="preview-image" alt="预览图片">
        <div v-else class="no-image">暂无预览图片</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="previewDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 批改结果对话框 -->
    <el-dialog title="批改结果" :visible.sync="judgeResultDialogVisible" width="90%" :close-on-click-modal="false">
      <div class="judge-result-container" v-if="currentJudgeResult">
        <!-- 处理judgeQuestion原始响应格式 -->
        <div v-if="currentJudgeResult.result && currentJudgeResult.result.length > 0">
          <div v-for="(studentResult, index) in currentJudgeResult.result" :key="index" class="student-result">
            <!-- 学生信息和总体状态 -->
            <div class="student-header">
              <div class="student-info">
                <h3>学生：{{ studentResult.student_name }} ({{ studentResult.student_num }})</h3>
              </div>
              <div class="overall-status">
                <el-tag :type="getOverallStatusType(studentResult.results)" size="large">
                  {{ getOverallStatusText(studentResult.results) }}
                </el-tag>
              </div>
            </div>

            <!-- 统计信息 -->
            <div class="statistics" v-if="studentResult.results && studentResult.results.length > 0">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="stat-item">
                    <div class="stat-number">{{ studentResult.results.length }}</div>
                    <div class="stat-label">总题数</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stat-item correct">
                    <div class="stat-number">{{ getCorrectCount(studentResult.results) }}</div>
                    <div class="stat-label">正确</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stat-item error">
                    <div class="stat-number">{{ getErrorCount(studentResult.results) }}</div>
                    <div class="stat-label">错误</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stat-item">
                    <div class="stat-number">{{ getAccuracy(studentResult.results) }}%</div>
                    <div class="stat-label">正确率</div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 题目详情表格 -->
            <div class="questions-table" v-if="studentResult.results && studentResult.results.length > 0">
              <el-table :data="getSortedResults(studentResult.results)" border style="width: 100%; margin-top: 20px;" :row-class-name="getRowClassName">
                <el-table-column prop="matched_index" label="题号" width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag size="small" type="info">{{ scope.row.matched_index }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="stem" label="题目" min-width="300">
                  <template slot-scope="scope">
                    <div class="question-content" v-html="renderLatex(scope.row.stem)"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="student_answer" label="学生答案" width="200">
                  <template slot-scope="scope">
                    <div class="answer-content" v-html="renderLatex(scope.row.student_answer)"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="judge" label="判断结果" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.judge === 'right' ? 'success' : 'danger'" size="medium">
                      {{ scope.row.judge === 'right' ? '正确' : '错误' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="answer" label="标准答案" width="200">
                  <template slot-scope="scope">
                    <div class="answer-content" v-html="renderLatex(scope.row.answer)"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="comment" label="评语" min-width="250">
                  <template slot-scope="scope">
                    <div class="comment-content" v-if="scope.row.comment">
                      {{ scope.row.comment }}
                    </div>
                    <div class="comment-content" v-else style="color: #999;">-</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 处理旧格式（recognizedQuestions） -->
        <div v-else-if="currentJudgeResult.recognizedQuestions && currentJudgeResult.recognizedQuestions.length > 0">
          <div class="student-result">
            <!-- 学生信息和总体状态 -->
            <div class="student-header">
              <div class="student-info">
                <h3>学生：批量上传结果</h3>
              </div>
              <div class="overall-status">
                <el-tag :type="getOverallStatusType(currentJudgeResult.recognizedQuestions)" size="large">
                  {{ getOverallStatusText(currentJudgeResult.recognizedQuestions) }}
                </el-tag>
              </div>
            </div>

            <!-- 统计信息 -->
            <div class="statistics">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="stat-item">
                    <div class="stat-number">{{ currentJudgeResult.recognizedQuestions.length + (currentJudgeResult.unrecognizedQuestions ? currentJudgeResult.unrecognizedQuestions.length : 0) }}</div>
                    <div class="stat-label">总题数</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stat-item correct">
                    <div class="stat-number">{{ getCorrectCount(currentJudgeResult.recognizedQuestions) }}</div>
                    <div class="stat-label">正确</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stat-item error">
                    <div class="stat-number">{{ getErrorCount(currentJudgeResult.recognizedQuestions) }}</div>
                    <div class="stat-label">错误</div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="stat-item">
                    <div class="stat-number">{{ getAccuracy(currentJudgeResult.recognizedQuestions) }}%</div>
                    <div class="stat-label">正确率</div>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!-- 题目详情表格 -->
            <div class="questions-table">
              <el-table :data="getSortedResults(currentJudgeResult.recognizedQuestions)" border style="width: 100%; margin-top: 20px;" :row-class-name="getRowClassName">
                <el-table-column prop="matched_index" label="题号" width="80" align="center">
                  <template slot-scope="scope">
                    <el-tag size="small" type="info">{{ scope.row.matched_index || (scope.$index + 1) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="content" label="题目" min-width="300">
                  <template slot-scope="scope">
                    <div class="question-content" v-html="renderLatex(scope.row.content || scope.row.stem)"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="studentAnswer" label="学生答案" width="200">
                  <template slot-scope="scope">
                    <div class="answer-content" v-html="renderLatex(scope.row.studentAnswer)"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="judge" label="判断结果" width="100" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.judge === 'right' ? 'success' : 'danger'" size="medium">
                      {{ scope.row.judge === 'right' ? '正确' : '错误' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="answer" label="标准答案" width="200">
                  <template slot-scope="scope">
                    <div class="answer-content" v-html="renderLatex(scope.row.answer || scope.row.correctAnswer)"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="comment" label="评语" min-width="250">
                  <template slot-scope="scope">
                    <div class="comment-content" v-if="scope.row.comment">
                      {{ scope.row.comment }}
                    </div>
                    <div class="comment-content" v-else style="color: #999;">-</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div v-else>
          <el-descriptions :column="2" border>
            <el-descriptions-item label="批改状态">
              <el-tag type="danger">失败</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="批改详情" :span="2">
              <pre style="white-space: pre-wrap; max-height: 300px; overflow-y: auto;">{{ JSON.stringify(currentJudgeResult, null, 2) }}</pre>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
      <div v-else class="no-result">
        暂无批改结果
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="judgeResultDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStudentSubmissionsByStudentId, addStudentSubmission, uploadFile, judgeQuestion, saveCorrectionResult, updateSubmissionStatus, addWrongQuestion, getSpecificHomeworkQuestions, getHomeworkList } from '@/api/homework';
import { getUsersByGradeId } from '@/api/user';
import { getToken } from '@/utils/auth';
import { parseJwt } from '@/utils/jwtUtils';

export default {
  name: 'BatchStudentUpload',
  props: {
    homework: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  data() {
    return {
      activeTab: 'single',
      selectedStudent: null,
      fileList: [],
      batchFileList: [],
      uploadHistory: [],
      studentList: [],
      uploading: false,
      previewDialogVisible: false,
      previewImageUrl: '',

      // 批改结果对话框相关数据
      judgeResultDialogVisible: false,
      currentJudgeResult: null,

             // 作业信息
       homeworkId: null,
       homeworkInfo: null,
       currentHomework: null, // 当前作业对象，包含题目信息

      // 文件夹/压缩包上传相关数据
      folderUploadType: 'folder', // folder或zip
      selectedFolderName: '',
      folderFiles: [], // 存储文件夹中的所有文件
      folderPreviewList: [], // 文件夹预览列表
      folderFileCount: 0, // 文件夹文件数量
      zipFileList: [], // ZIP文件列表
      extractedFiles: [], // 从ZIP中提取的文件列表
      serverSavePath: '', // 服务器保存路径
      uploadPath: 'homework_images/', // 上传路径前缀

      // 批量匹配工具数据
      patternMatch: {
        pattern: '',
        studentId: null
      },
      sequenceMatch: {
        studentIds: []
      }
    }
  },
  computed: {
    canSubmitSingle() {
      return this.selectedStudent && this.fileList.length > 0;
    },
    canSubmitBatch() {
      return this.batchFileList.length > 0;
    },
    canSubmitFolder() {
      if (this.folderUploadType === 'folder') {
        return this.folderFiles.length > 0;
      } else {
        return this.zipFileList.length > 0;
      }
    },
    matchedCount() {
      return this.folderPreviewList.filter(item => item.status === 'matched').length;
    },
    unmatchedCount() {
      return this.folderPreviewList.filter(item => item.status === 'unmatched').length;
    },
    canMatchByPattern() {
      return this.patternMatch.pattern && this.patternMatch.studentId;
    },
    canMatchBySequence() {
      return this.sequenceMatch.studentIds && this.sequenceMatch.studentIds.length > 0;
    }
  },
     async created() {
     console.log('BatchStudentUpload created');
     console.log('Route params:', this.$route.params);
     console.log('Route query:', this.$route.query);
     console.log('Homework prop:', this.homework);
     await this.initHomeworkInfo();
     await this.fetchStudentList();
   },
  methods: {
         // 初始化作业信息
     async initHomeworkInfo() {
       // 从路由参数获取homeworkId
       this.homeworkId = this.$route.params.id;

       // 如果有props传入的homework对象，使用它
       if (this.homework && this.homework.id) {
         this.homeworkInfo = this.homework;
         this.currentHomework = this.homework;
       } else {
         // 否则从路由query中获取作业名称
         this.homeworkInfo = {
           id: this.homeworkId,
           name: this.$route.query.homeworkName || '未知作业',
           createTime: new Date().toLocaleString(),
           createPerson: '当前用户',
           className: '未指定班级'
         };
       }

               console.log('作业ID:', this.homeworkId, '类型:', typeof this.homeworkId);
        console.log('作业信息:', this.homeworkInfo);

              // 获取作业的题目列表和答案
       await this.fetchHomeworkQuestions();
     },

     // 获取作业的题目列表和答案
     async fetchHomeworkQuestions() {
       try {
         // 1. 获取特定作业的题目列表
         const homeworkQuestionsResponse = await getSpecificHomeworkQuestions(this.homeworkId);

         if (homeworkQuestionsResponse && homeworkQuestionsResponse.data) {
           const questions = homeworkQuestionsResponse.data;

           // 直接使用getSpecificHomeworkQuestions返回的题目数据，已经包含答案
           const questionsWithDetails = questions.map(question => ({
             content: question.content || question.stem || '',
             stem: question.content || question.stem || '',
             answer: question.answer || '',
             knowledge: question.knowledge || '',
             analysis: question.analysis || ''
           }));

           // 更新 currentHomework 对象
           this.currentHomework = {
             id: this.homeworkId,
             name: this.homeworkInfo.name,
             questions: questionsWithDetails
           };

           console.log('获取到的作业题目和答案:', this.currentHomework);
         } else {
           console.warn('未获取到作业题目列表');
           // 如果没有获取到题目，初始化为空数组
           this.currentHomework = {
             id: this.homeworkId,
             name: this.homeworkInfo.name,
             questions: []
           };
         }
       } catch (error) {
         console.error('获取作业题目失败:', error);
         // 如果获取失败，初始化为空数组
         this.currentHomework = {
           id: this.homeworkId,
           name: this.homeworkInfo.name,
           questions: []
         };
       }
     },

           // 获取学生列表
     async fetchStudentList() {
       try {
         // 首先获取作业列表，找到当前作业的gradeId
         const homeworkListResponse = await getHomeworkList();

         if (homeworkListResponse && homeworkListResponse.data) {
                       // 找到当前作业 - 转换为数字进行比较
            const currentHomework = homeworkListResponse.data.find(hw => hw.id === parseInt(this.homeworkId));

           if (currentHomework) {
             // 获取gradeId，兼容不同的字段名
             const gradeId = currentHomework.gradeId || currentHomework.grade_id;

             if (gradeId) {
               console.log('当前作业的gradeId:', gradeId);

               // 使用getUsersByGradeId获取该班级的学生列表
               const usersResponse = await getUsersByGradeId(gradeId);

               if (usersResponse && usersResponse.data) {
                 this.studentList = usersResponse.data.map(user => ({
                   id: user.id,
                   username: user.username || user.realName || user.name || `学生${user.id}`
                 }));
                 console.log('获取到的学生列表:', this.studentList);
               } else {
                 console.warn('未获取到学生列表数据');
                 this.studentList = [];
               }
             } else {
               console.warn('当前作业没有gradeId，无法获取学生列表');
               this.studentList = [];
             }
           } else {
             console.warn('未找到当前作业信息');
             this.studentList = [];
           }
         } else {
           console.warn('未获取到作业列表');
           this.studentList = [];
         }
       } catch (error) {
         console.error('获取学生列表失败:', error);
         this.$message.error('获取学生列表失败，将使用默认列表');

         // 如果获取失败，使用默认的学生列表作为备选
         this.studentList = [
           { id: 1, username: 'student' },
           { id: 2, username: 'student1' },
           { id: 3, username: 'student2' },
           { id: 4, username: 'student3' },
           { id: 5, username: 'student5' },
           { id: 6, username: 'student13' },
           { id: 7, username: 'student14' }
         ];
       }
     },

    // 处理单个文件变化
    handleFileChange(file, fileList) {
      this.fileList = fileList;
    },

    // 处理单个文件移除
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },

    // 处理批量文件变化
    handleBatchFileChange(file, fileList) {
      this.batchFileList = fileList;
    },

    // 处理批量文件移除
    handleBatchFileRemove(file, fileList) {
      this.batchFileList = fileList;
    },

         // 提交单个上传
     async submitSingleUpload() {
       if (!this.canSubmitSingle) {
         this.$message.warning('请选择学生和文件');
         return;
       }

       if (!this.selectedStudent) {
         this.$message.warning('请先选择学生');
         return;
       }

       this.uploading = true;
       try {
         const file = this.fileList[0].raw;
         const student = this.studentList.find(s => s.id === this.selectedStudent);

         // 1. 上传图片到 MinIO
         const uploadFormData = new FormData();
         uploadFormData.append('file', file);
         const minioResponse = await uploadFile(uploadFormData);

         if (minioResponse.code !== 1) {
           throw new Error(minioResponse.msg || '文件上传失败');
         }

         const imageUrl = `http://localhost:8080/api/files${minioResponse.msg}`;

         // 2. 调用 judgeQuestion 接口对图片进行批改
         // 获取当前作业的题目列表
         const currentHomeworkQuestions = this.currentHomework.questions || [];

         // 添加调试信息
         console.log('=== judgeQuestion 调试信息 ===');
         console.log('currentHomework:', this.currentHomework);
         console.log('currentHomeworkQuestions:', currentHomeworkQuestions);
         console.log('currentHomeworkQuestions.length:', currentHomeworkQuestions.length);

         // 检查是否有题目数据
         if (currentHomeworkQuestions.length === 0) {
           throw new Error('当前作业没有题目数据，无法进行批改');
         }

         const questions = {
           question_list: currentHomeworkQuestions.map(q => ({
             stems: q.content || q.stem || '',
             answer: q.answer || ''
           }))
         };

         console.log('构建的questions参数:', questions);
         console.log('questions.question_list:', questions.question_list);

         // 验证questions参数格式
         if (!questions.question_list || questions.question_list.length === 0) {
           throw new Error('题目参数格式错误或为空');
         }

         // 验证每个题目是否有必要的字段
         const invalidQuestions = questions.question_list.filter(q => !q.stems || !q.answer);
         if (invalidQuestions.length > 0) {
           console.warn('发现无效题目:', invalidQuestions);
           throw new Error(`发现 ${invalidQuestions.length} 道题目缺少题干或答案`);
         }

         const response = await judgeQuestion(file, questions);

         // 3. 处理判题结果
         console.log('判题结果:', response);

         if (response && response.result && response.result.length > 0) {
           const judgeResult = response.result[0];
           const results = judgeResult.results || [];

           // 检查results数组是否为空，如果为空表示批改失败
           if (!results || results.length === 0) {
             const studentName = judgeResult.student_name || '未知学生';
             console.warn(`学生 ${studentName} 的作业批改失败，results为空`);
             this.$message.error('作业批改失败，未识别到任何题目');

             // 记录错误到历史记录
             this.uploadHistory.unshift({
               studentName: studentName,
               fileName: this.fileList[0].name,
               uploadTime: new Date().toLocaleString(),
               status: 'error',
               imageUrl: URL.createObjectURL(this.fileList[0].raw),
               errorMessage: '作业批改失败，未识别到任何题目'
             });
             return;
           }

           // 根据 matched_index 判断哪些题目被识别了
           const recognizedQuestions = [];
           const unrecognizedQuestions = [];

           // 遍历所有题目，检查哪些被识别了
           currentHomeworkQuestions.forEach((question, index) => {
             const matchedResult = results.find(r => r.matched_index === index + 1);

             if (matchedResult) {
               // 题目被识别了
               recognizedQuestions.push({
                 ...question,
                 judge: matchedResult.judge,
                 studentAnswer: matchedResult.student_answer,
                 comment: matchedResult.comment,
                 correctAnswer: matchedResult.answer || question.answer
               });
             } else {
               // 题目没有被识别
               unrecognizedQuestions.push({
                 ...question,
                 judge: 'unrecognized',
                 studentAnswer: '',
                 comment: '题目未被识别',
                 correctAnswer: question.answer
               });
             }
           });

           console.log('识别的题目:', recognizedQuestions);
           console.log('未识别的题目:', unrecognizedQuestions);

                       // 4. 创建学生提交记录
            const submissionResponse = await addStudentSubmission({
              homeworkId: this.homeworkId,
              studentId: this.selectedStudent, // 使用选择的学生ID
              submitted: true,
              imageUrl: imageUrl,
              status: '已批改' // 直接在创建时就设置为已批改
            });

           if (!submissionResponse || typeof submissionResponse.id === 'undefined') {
             throw new Error('学生提交记录创建失败');
           }

                       // 5. 保存每个题目的判题结果到数据库
            console.log('开始保存每个题目的判题结果，共', results.length, '个结果');

            for (const result of results) {
              try {
                // 根据 matched_index 找到对应的题目
                const questionIndex = result.matched_index - 1;
                const question = currentHomeworkQuestions[questionIndex];

                if (question) {
                  // 构造单个题目的判题结果数据
                  const correctionData = {
                    homeworkId: this.homeworkId,
                    studentId: studentId,
                    stem: result.stem || question.content || question.stem || '',
                    judge: result.judge === 'right' ? '正确' : (result.judge === 'error' ? '错误' : '未识别'),
                    comment: result.comment || '',
                    point: result.judge === 'right' ? 10 : 0 // 可以根据需要调整分数
                  };

                  console.log(`保存第${result.matched_index}题判题结果:`, correctionData);
                  await saveCorrectionResult(correctionData);
                  console.log(`第${result.matched_index}题判题结果保存成功`);
                } else {
                  console.warn(`未找到第${result.matched_index}题对应的题目信息`);
                }
              } catch (error) {
                console.error(`保存第${result.matched_index}题判题结果失败:`, error);
              }
            }

            console.log('所有题目判题结果保存完成');

            // 6. 添加错题到错题本
            try {
              const wrongQuestions = results.filter(result => result.judge === 'error');
              if (wrongQuestions.length > 0) {
                console.log(`发现 ${wrongQuestions.length} 道错题，开始添加到错题本`);

                for (const wrongResult of wrongQuestions) {
                  try {
                    const questionIndex = wrongResult.matched_index - 1;
                    const question = currentHomeworkQuestions[questionIndex];

                    const wrongQuestionData = {
                      student_id: studentId,
                      content: wrongResult.stem || question?.content || question?.stem || '',
                      analysis: wrongResult.comment || '',
                      knowledge: question?.knowledge || '',
                      chapter: '', // 默认为空
                      suboptions: '数学', // 默认为数学
                      answer: question?.answer || '',
                      wrongCount: 1,
                      mastered: false
                    };

                    console.log(`添加错题到错题本:`, wrongQuestionData);
                    await addWrongQuestion(wrongQuestionData);
                    console.log(`第${wrongResult.matched_index}题已添加到错题本`);
                  } catch (error) {
                    console.error(`添加第${wrongResult.matched_index}题到错题本失败:`, error);
                  }
                }

                this.$message.success(`已将 ${wrongQuestions.length} 道错题加入错题本`);
              } else {
                console.log('没有错题需要添加到错题本');
              }
            } catch (error) {
              console.error('添加错题到错题本失败:', error);
              this.$message.warning('部分错题添加失败，请检查错题本');
            }

            // 7. 更新提交状态
            try {
              // 只要judgeQuestion不返回空值就一律写入已批改
              const status = '已批改';
              console.log(`准备更新状态为${status}，参数:`, this.homeworkId, this.selectedStudent);
              console.log(`处理结果数量: ${results.length}, 识别题目数: ${recognizedQuestions.length}, 未识别题目数: ${unrecognizedQuestions.length}`);

              const updateResponse = await updateSubmissionStatus(this.homeworkId, this.selectedStudent, status);
              console.log(`学生 ${this.selectedStudent} 提交状态更新响应:`, updateResponse);
              console.log(`学生 ${this.selectedStudent} 提交状态更新为${status}`);
            } catch (error) {
              console.error(`学生 ${this.selectedStudent} 提交状态更新失败:`, error);
            }

            // 7. 添加到上传历史
           this.uploadHistory.unshift({
             studentName: student ? student.username : '未知学生',
             fileName: file.name,
             uploadTime: new Date().toLocaleString(),
             status: 'success',
             imageUrl: imageUrl,
             judgeResult: response
           });

           this.$message.success(`判题完成！识别了 ${recognizedQuestions.length} 道题目，${unrecognizedQuestions.length} 道题目未识别`);
           this.resetSingleUpload();
         } else {
           throw new Error('批改失败');
         }
       } catch (error) {
         console.error('上传失败', error);
         this.$message.error('上传失败：' + error.message);

         // 记录错误到历史记录
         this.uploadHistory.unshift({
           studentName: this.studentList.find(s => s.id === this.selectedStudent)?.username || '未知学生',
           fileName: this.fileList[0].name,
           uploadTime: new Date().toLocaleString(),
           status: 'error',
           imageUrl: URL.createObjectURL(this.fileList[0].raw),
           errorMessage: error.message || '处理失败'
         });
       } finally {
         this.uploading = false;
       }
     },

          // 提交批量上传
     async submitBatchUpload() {
       if (!this.canSubmitBatch) {
         this.$message.warning('请至少上传一个文件');
         return;
       }

       // 移除学生选择验证，将使用judgeQuestion返回的学生信息

  this.uploading = true;
  try {
    // 获取所有文件
    const files = this.batchFileList.map(file => file.raw);

    // 收集所有批改结果
    const allCorrectionResults = [];

    // 逐个处理文件
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      try {
        // 显示当前正在处理的图片信息
        this.$message({
          message: `正在上传并批改第 ${i + 1} 张图片...`,
          type: 'info',
          duration: 1500
        });

        // 1. 上传当前的图片到 MinIO
        const uploadFormData = new FormData();
        uploadFormData.append('file', file);
        const minioResponse = await uploadFile(uploadFormData);

        // 检查上传结果
        if (minioResponse.code !== 1) {
          console.error(`图片 ${i + 1} 上传失败:`, minioResponse.msg || '未知错误');
          this.uploadHistory.unshift({
            studentName: '未知学生',
            fileName: file.name,
            uploadTime: new Date().toLocaleString(),
            status: 'error',
            imageUrl: URL.createObjectURL(file),
            errorMessage: minioResponse.msg || '文件上传失败'
          });
          continue; // 当前图片处理失败，跳过后续步骤，继续处理下一张
        }

        const imageUrl = `http://localhost:8080/api/files${minioResponse.msg}`;

        // 2. 调用 judgeQuestion 接口对当前的图片进行批改
        const currentHomeworkQuestions = this.currentHomework.questions || [];

        // 添加调试信息
        console.log('=== 批量上传 judgeQuestion 调试信息 ===');
        console.log('currentHomework:', this.currentHomework);
        console.log('currentHomeworkQuestions:', currentHomeworkQuestions);
        console.log('currentHomeworkQuestions.length:', currentHomeworkQuestions.length);

        // 检查是否有题目数据
        if (currentHomeworkQuestions.length === 0) {
          throw new Error('当前作业没有题目数据，无法进行批改');
        }

        const questions = {
          question_list: currentHomeworkQuestions.map(q => ({
            stems: q.content || q.stem || '',
            answer: q.answer || ''
          }))
        };

        console.log('构建的questions参数:', questions);
        console.log('questions.question_list:', questions.question_list);

        // 验证questions参数格式
        if (!questions.question_list || questions.question_list.length === 0) {
          throw new Error('题目参数格式错误或为空');
        }

        // 验证每个题目是否有必要的字段
        const invalidQuestions = questions.question_list.filter(q => !q.stems || !q.answer);
        if (invalidQuestions.length > 0) {
          console.warn('发现无效题目:', invalidQuestions);
          throw new Error(`发现 ${invalidQuestions.length} 道题目缺少题干或答案`);
        }

        const response = await judgeQuestion(file, questions);

                // 3. 处理判题结果
        if (response && response.result && response.result.length > 0) {
          const judgeResult = response.result[0];
          const results = judgeResult.results || [];

          // 从judgeQuestion结果中提取学生信息
          const studentId = judgeResult.student_num;
          const studentName = judgeResult.student_name;

          if (!studentId) {
            console.warn('judgeQuestion结果中未找到学生ID，跳过此文件');
            this.uploadHistory.unshift({
              studentName: '未知学生',
              fileName: file.name,
              uploadTime: new Date().toLocaleString(),
              status: 'error',
              imageUrl: URL.createObjectURL(file),
              errorMessage: '未识别到学生信息'
            });
            continue; // 跳过当前文件，继续处理下一个
          }

          // 检查results数组是否为空，如果为空表示批改失败
          if (!results || results.length === 0) {
            console.warn(`学生 ${studentName} (ID: ${studentId}) 的作业批改失败，results为空`);
            this.uploadHistory.unshift({
              studentName: studentName || '未知学生',
              fileName: file.name,
              uploadTime: new Date().toLocaleString(),
              status: 'error',
              imageUrl: imageUrl,
              errorMessage: '作业批改失败，未识别到任何题目'
            });
            continue; // 跳过当前文件，继续处理下一个
          }

          console.log(`识别到学生: ${studentName} (ID: ${studentId})，批改成功，识别到 ${results.length} 道题目`);

          // 根据 matched_index 判断哪些题目被识别了
          const recognizedQuestions = [];
          const unrecognizedQuestions = [];

          currentHomeworkQuestions.forEach((question, index) => {
            const matchedResult = results.find(r => r.matched_index === index + 1);

            if (matchedResult) {
              recognizedQuestions.push({
                ...question,
                judge: matchedResult.judge,
                studentAnswer: matchedResult.student_answer,
                comment: matchedResult.comment,
                correctAnswer: matchedResult.answer || question.answer
              });
            } else {
              unrecognizedQuestions.push({
                ...question,
                judge: 'unrecognized',
                studentAnswer: '',
                comment: '题目未被识别',
                correctAnswer: question.answer
              });
            }
          });

                                                                 // 保存每个题目的判题结果到数据库
            console.log('开始保存每个题目的判题结果，共', results.length, '个结果');

            for (const result of results) {
              try {
                // 根据 matched_index 找到对应的题目
                const questionIndex = result.matched_index - 1;
                const question = currentHomeworkQuestions[questionIndex];

                if (question) {
                  // 构造单个题目的判题结果数据
                  const correctionData = {
                    homeworkId: this.homeworkId,
                    studentId: studentId,
                    stem: result.stem || question.content || question.stem || '',
                    judge: result.judge === 'right' ? '正确' : (result.judge === 'error' ? '错误' : '未识别'),
                    comment: result.comment || '',
                    point: result.judge === 'right' ? 10 : 0 // 可以根据需要调整分数
                  };

                  console.log(`保存第${result.matched_index}题判题结果:`, correctionData);
                  await saveCorrectionResult(correctionData);
                  console.log(`第${result.matched_index}题判题结果保存成功`);
                } else {
                  console.warn(`未找到第${result.matched_index}题对应的题目信息`);
                }
              } catch (error) {
                console.error(`保存第${result.matched_index}题判题结果失败:`, error);
              }
            }

            console.log('所有题目判题结果保存完成');

            // 添加错题到错题本
            try {
              const wrongQuestions = results.filter(result => result.judge === 'error');
              if (wrongQuestions.length > 0) {
                console.log(`发现 ${wrongQuestions.length} 道错题，开始添加到错题本`);

                for (const wrongResult of wrongQuestions) {
                  try {
                    const questionIndex = wrongResult.matched_index - 1;
                    const question = currentHomeworkQuestions[questionIndex];

                    const wrongQuestionData = {
                      student_id: studentId,
                      content: wrongResult.stem || question?.content || question?.stem || '',
                      analysis: wrongResult.comment || '',
                      knowledge: question?.knowledge || '',
                      chapter: '', // 默认为空
                      suboptions: '数学', // 默认为数学
                      answer: question?.answer || '',
                      wrongCount: 1,
                      mastered: false
                    };

                    console.log(`添加错题到错题本:`, wrongQuestionData);
                    await addWrongQuestion(wrongQuestionData);
                    console.log(`第${wrongResult.matched_index}题已添加到错题本`);
                  } catch (error) {
                    console.error(`添加第${wrongResult.matched_index}题到错题本失败:`, error);
                  }
                }

                this.$message.success(`已将 ${wrongQuestions.length} 道错题加入错题本`);
              } else {
                console.log('没有错题需要添加到错题本');
              }
            } catch (error) {
              console.error('添加错题到错题本失败:', error);
              this.$message.warning('部分错题添加失败，请检查错题本');
            }

                                            // 创建学生提交记录
            const submissionResponse = await addStudentSubmission({
              homeworkId: this.homeworkId,
              studentId: studentId, // 使用从judgeQuestion结果中提取的学生ID
              submitted: true,
              imageUrl: imageUrl,
              status: '已批改' // 直接在创建时就设置为已批改
            });

          if (submissionResponse && submissionResponse.id) {
            console.log(`学生提交记录创建成功:`, submissionResponse);
          }

                     // 添加到总结果列表
           const resultItem = {
             imageUrl: imageUrl,
             fileName: file.name,
             recognizedQuestions: recognizedQuestions,
             unrecognizedQuestions: unrecognizedQuestions,
             totalQuestions: currentHomeworkQuestions.length,
             recognizedCount: recognizedQuestions.length,
             unrecognizedCount: unrecognizedQuestions.length,
             studentId: studentId
           };
           allCorrectionResults.push(resultItem);
           console.log('添加批改结果到总列表:', resultItem);

          // 保存到历史记录
          this.uploadHistory.unshift({
            studentName: studentName || '未知学生',
            fileName: file.name,
            uploadTime: new Date().toLocaleString(),
            status: 'success',
            imageUrl: imageUrl,
            judgeResult: response // 保存原始的judgeQuestion响应
          });

                     this.$message.success(`判题完成！识别了 ${recognizedQuestions.length} 道题目，${unrecognizedQuestions.length} 道题目未识别`);

           // 立即更新提交状态
           try {
             // 只要judgeQuestion不返回空值就一律写入已批改
             const status = '已批改';
             console.log(`准备更新状态为${status}，参数:`, this.homeworkId, studentId);
             console.log(`处理结果数量: ${results.length}, 识别题目数: ${recognizedQuestions.length}, 未识别题目数: ${unrecognizedQuestions.length}`);

             const updateResponse = await updateSubmissionStatus(this.homeworkId, studentId, status);
             console.log(`学生 ${studentId} 提交状态更新响应:`, updateResponse);
             console.log(`学生 ${studentId} 提交状态更新为${status}`);
           } catch (error) {
             console.error(`学生 ${studentId} 提交状态更新失败:`, error);
           }
         } else {
           throw new Error('判题结果格式错误');
         }
      } catch (error) {
        console.error(`处理文件 ${file.name} 时出错:`, error);

        this.uploadHistory.unshift({
          studentName: '未知学生',
          fileName: file.name,
          uploadTime: new Date().toLocaleString(),
          status: 'error',
          imageUrl: URL.createObjectURL(file),
          errorMessage: error.message || '处理失败'
        });
      }
    }

                   // 7. 状态更新已在每个文件处理完成后立即进行，这里不需要重复更新

         // 8. 添加错题到错题本
     if (allCorrectionResults.length > 0) {
       // 从所有结果中提取错题
       const wrongQuestions = [];
       allCorrectionResults.forEach(result => {
         if (result.recognizedQuestions && result.recognizedQuestions.length > 0) {
           const wrongOnes = result.recognizedQuestions.filter(q => q.judge === 'error');
           wrongQuestions.push(...wrongOnes);
         }
       });

       if (wrongQuestions.length > 0) {
         try {
           const addToWrongBookPromises = wrongQuestions.map(question =>
             addWrongQuestion({
               studentid: studentId,
               content: question.content || question.stem || '',
               analysis: question.comment || '',
               knowledge: question.knowledge || '',
               chapter: '',
               suboptions: '数学',
               answer: question.answer || ''
             })
           );

           await Promise.all(addToWrongBookPromises);
           this.$message.success(`已将 ${wrongQuestions.length} 道错题加入错题本`);
         } catch (error) {
           console.error('添加错题到错题本失败:', error);
           this.$message.warning('部分错题添加失败，请检查错题本');
         }
       }
     }

    this.$message.success(`成功处理 ${files.length} 个文件`);
    this.resetBatchUpload();
  } catch (error) {
    console.error('批量上传失败', error);
    this.$message.error('批量上传失败，请重试');
  } finally {
    this.uploading = false;
  }
},

    // 重置单个上传
    resetSingleUpload() {
      this.selectedStudent = null;
      this.fileList = [];
    },

    // 重置批量上传
    resetBatchUpload() {
      this.batchFileList = [];
    },

    // 预览图片
    previewImage(item) {
      this.previewImageUrl = item.imageUrl;
      this.previewDialogVisible = true;
    },

    // 查看批改结果
    viewJudgeResult(item) {
      console.log('查看批改结果，数据结构:', item.judgeResult);
      this.currentJudgeResult = item.judgeResult;
      this.judgeResultDialogVisible = true;
    },

    // 实际项目中的文件上传方法
    async realUploadFile(file) {
      try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await uploadFile(formData);

        if (response.code === 1) {
          return {
            success: true,
            imageUrl: `http://localhost:8080/api/file${response.msg}`
          };
        } else {
          return {
            success: false,
            message: response.msg || '上传失败'
          };
        }
      } catch (error) {
        console.error('文件上传失败:', error);
        return {
          success: false,
          message: '文件上传失败，请重试'
        };
      }
    },

         // 实际项目中添加学生提交记录
     async addSubmission(studentId, imageUrl) {
       try {
         const response = await addStudentSubmission({
           homeworkId: this.homeworkId,
           studentId: studentId,
           submitted: true,
           imageUrl: imageUrl
         });

         return !!(response && response.id);
       } catch (error) {
         console.error('添加提交记录失败:', error);
         return false;
       }
     },

    // 文件夹上传相关方法
    triggerFolderInput() {
      this.$refs.folderInput.click();
    },

    handleFolderSelect(e) {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      // 获取并保存文件夹名称
      const path = files[0].webkitRelativePath;
      this.selectedFolderName = path.split('/')[0];
      this.folderFileCount = files.length;

      // 过滤图片文件
      this.folderFiles = Array.from(files).filter(file => {
        const ext = file.name.split('.').pop().toLowerCase();
        return ['jpg', 'jpeg', 'png', 'gif'].includes(ext);
      });

      // 更新预览
      this.updateFolderPreview();
    },

    updateFolderPreview() {
      // 保存当前已手动匹配的项目
      const manualMatches = {};
      this.folderPreviewList.forEach(item => {
        if (item.status === 'matched' && !item.autoMatched) {
          manualMatches[item.fileName] = {
            studentId: item.studentId,
            studentName: item.studentName
          };
        }
      });

      this.folderPreviewList = this.folderFiles.map(file => {
        const fileName = file.name;

        // 检查是否已经手动匹配过
        if (manualMatches[fileName]) {
          return {
            fileName,
            studentId: manualMatches[fileName].studentId,
            studentName: manualMatches[fileName].studentName,
            status: 'matched',
            autoMatched: false,
            file: file
          };
        }

        // 自动匹配逻辑
        const fileNameWithoutExt = fileName.split('.')[0];
        const matchedStudent = this.studentList.find(student =>
          student.username.toLowerCase() === fileNameWithoutExt.toLowerCase()
        );

        return {
          fileName: fileName,
          studentName: matchedStudent ? matchedStudent.username : '未匹配',
          studentId: matchedStudent ? matchedStudent.id : null,
          status: matchedStudent ? 'matched' : 'unmatched',
          autoMatched: !!matchedStudent,
          file: file
        };
      });
    },

    handleZipChange(file) {
      this.zipFileList = [file];
      // 实际项目中需要通过服务端API解压ZIP文件并返回文件列表
      // 这里我们模拟这个过程
      this.simulateZipExtraction(file);
    },

    handleZipRemove() {
      this.zipFileList = [];
      this.folderFiles = [];
      this.folderPreviewList = [];
    },

    // 模拟ZIP文件解压过程
    simulateZipExtraction(zipFile) {
      // 在实际项目中，这里应该调用后端API上传并解压ZIP文件
      // 然后返回解压后的文件列表
      // 这里我们使用模拟数据
      this.uploading = true;

      // 模拟异步过程
      setTimeout(() => {
        // 假设ZIP里有这些文件
        const extractedFiles = [
          new File([new Blob()], 'student1.jpg', { type: 'image/jpeg' }),
          new File([new Blob()], 'student2.jpg', { type: 'image/jpeg' }),
          new File([new Blob()], 'student3.jpg', { type: 'image/jpeg' }),
          new File([new Blob()], 'student5.jpg', { type: 'image/jpeg' }),
          new File([new Blob()], 'unknown.jpg', { type: 'image/jpeg' })
        ];

        this.folderFiles = extractedFiles;
        this.updateFolderPreview();
        this.uploading = false;
      }, 1500);
    },

    async submitFolderUpload() {
      if (!this.canSubmitFolder) {
        this.$message.warning('请先选择文件夹或ZIP文件');
        return;
      }

      this.uploading = true;

      try {
        // 只处理已匹配的文件
        const matchedFiles = this.folderPreviewList.filter(item => item.status === 'matched');
        if (matchedFiles.length === 0) {
          this.$message.warning('没有匹配的文件可以上传');
          this.uploading = false;
          return;
        }

                 // 保存服务器路径 (基于作业ID和当前时间)
         const timestamp = new Date().getTime();
         const homeworkId = this.homeworkId;
         this.serverSavePath = `${this.uploadPath}homework_${homeworkId}_${timestamp}/`;

        // 在实际项目中，这里应该是一个循环上传所有文件到服务器的过程
        // 上传并处理每个匹配的文件
        for (const item of matchedFiles) {
          // 1. 上传文件到服务器
          const uploadResult = await this.realUploadFile(item.file);

          if (uploadResult.success) {
            // 2. 创建学生提交记录
            await this.addSubmission(item.studentId, uploadResult.imageUrl);

            // 3. 添加到上传历史
            this.uploadHistory.unshift({
              studentName: item.studentName,
              fileName: item.fileName,
              uploadTime: new Date().toLocaleString(),
              status: 'success',
              imageUrl: uploadResult.imageUrl || URL.createObjectURL(item.file) // 临时URL用于预览
            });
          } else {
            this.uploadHistory.unshift({
              studentName: item.studentName,
              fileName: item.fileName,
              uploadTime: new Date().toLocaleString(),
              status: 'failed',
              errorMsg: uploadResult.message || '上传失败'
            });
          }
        }

        this.$message.success(`成功上传 ${matchedFiles.length} 个文件`);
        this.resetFolderUpload();
      } catch (error) {
        console.error('批量上传失败', error);
        this.$message.error('批量上传失败，请重试');
      } finally {
        this.uploading = false;
      }
    },

    resetFolderUpload() {
      this.selectedFolderName = '';
      this.folderFiles = [];
      this.folderPreviewList = [];
      this.zipFileList = [];
      this.folderFileCount = 0;
      if (this.$refs.folderInput) {
        this.$refs.folderInput.value = '';
      }
    },

    // 手动匹配学生
    handleManualMatch(row) {
      if (row.studentId) {
        const student = this.studentList.find(s => s.id === row.studentId);
        if (student) {
          row.studentName = student.username;
          row.status = 'matched';
          row.autoMatched = false; // 标记为手动匹配
          this.$message.success(`已将文件 ${row.fileName} 手动匹配给学生 ${student.username}`);
        }
      }
    },

    // 取消匹配
    cancelMatch(row) {
      row.studentId = null;
      row.studentName = '未匹配';
      row.status = 'unmatched';
      row.autoMatched = false;
      this.$message.info(`已取消文件 ${row.fileName} 的匹配`);
    },

    // 按文件名模式批量匹配
    matchByPattern() {
      if (!this.canMatchByPattern) {
        return;
      }

      const pattern = this.patternMatch.pattern.toLowerCase();
      const studentId = this.patternMatch.studentId;
      const student = this.studentList.find(s => s.id === studentId);

      if (!student) {
        this.$message.warning('请选择有效的学生');
        return;
      }

      let matchedCount = 0;

      // 仅应用于文件夹上传模式
      const currentList = this.folderPreviewList;

      currentList.forEach(item => {
        // 仅处理未匹配的文件
        if (item.status === 'unmatched' && item.fileName.toLowerCase().includes(pattern)) {
          item.studentId = studentId;
          item.studentName = student.username;
          item.status = 'matched';
          item.autoMatched = false; // 标记为手动匹配
          matchedCount++;
        }
      });

      if (matchedCount > 0) {
        this.$message.success(`成功匹配 ${matchedCount} 个文件给学生 ${student.username}`);
      } else {
        this.$message.info('没有找到符合模式的未匹配文件');
      }
    },

    // 按顺序批量匹配
    matchBySequence() {
      if (!this.canMatchBySequence) {
        return;
      }

      const studentIds = [...this.sequenceMatch.studentIds]; // 复制数组，避免修改原数组
      if (studentIds.length === 0) {
        this.$message.warning('请选择至少一个学生');
        return;
      }

      // 仅应用于文件夹上传模式
      const currentList = this.folderPreviewList;
      const unmatchedFiles = currentList.filter(item => item.status === 'unmatched');

      let matchedCount = 0;
      let studentIndex = 0;

      // 顺序分配学生到未匹配的文件
      unmatchedFiles.forEach(item => {
        if (studentIndex >= studentIds.length) {
          studentIndex = 0; // 循环使用学生列表
        }

        const studentId = studentIds[studentIndex];
        const student = this.studentList.find(s => s.id === studentId);

        if (student) {
          item.studentId = studentId;
          item.studentName = student.username;
          item.status = 'matched';
          item.autoMatched = false; // 标记为手动匹配
          matchedCount++;
          studentIndex++;
        }
      });

      if (matchedCount > 0) {
        this.$message.success(`成功按顺序匹配 ${matchedCount} 个文件`);
      } else {
        this.$message.info('没有未匹配的文件需要处理');
      }
    },

    // 批改结果弹窗相关方法
    // 获取总体状态类型
    getOverallStatusType(results) {
      if (!results || results.length === 0) {
        return 'danger';
      }
      const correctCount = this.getCorrectCount(results);
      const totalCount = results.length;
      const accuracy = (correctCount / totalCount) * 100;

      if (accuracy >= 80) {
        return 'success';
      } else if (accuracy >= 60) {
        return 'warning';
      } else {
        return 'danger';
      }
    },

    // 获取总体状态文本
    getOverallStatusText(results) {
      if (!results || results.length === 0) {
        return '批改失败';
      }
      const correctCount = this.getCorrectCount(results);
      const totalCount = results.length;
      const accuracy = (correctCount / totalCount) * 100;

      if (accuracy >= 80) {
        return '批改成功';
      } else if (accuracy >= 60) {
        return '部分正确';
      } else {
        return '需要改进';
      }
    },

    // 获取正确题目数量
    getCorrectCount(results) {
      if (!results) return 0;
      return results.filter(result => result.judge === 'right').length;
    },

    // 获取错误题目数量
    getErrorCount(results) {
      if (!results) return 0;
      return results.filter(result => result.judge === 'error').length;
    },

    // 获取正确率
    getAccuracy(results) {
      if (!results || results.length === 0) return 0;
      const correctCount = this.getCorrectCount(results);
      return Math.round((correctCount / results.length) * 100);
    },

    // 获取表格行样式类名
    getRowClassName({ row, rowIndex }) {
      if (row.judge === 'right') {
        return 'success-row';
      } else if (row.judge === 'error') {
        return 'error-row';
      }
      return '';
    },

    // 对结果按matched_index排序
    getSortedResults(results) {
      if (!results || results.length === 0) return [];
      return [...results].sort((a, b) => (a.matched_index || 0) - (b.matched_index || 0));
    },

    // 渲染LaTeX数学公式
    renderLatex(text) {
      if (!text) return '';

      // 简单的LaTeX渲染处理
      let rendered = text
        // 处理换行
        .replace(/\n/g, '<br>')
        // 处理特殊字符（先处理这些，避免被其他规则影响）
        .replace(/\\leq/g, '≤')
        .replace(/\\geq/g, '≥')
        .replace(/\\neq/g, '≠')
        .replace(/\\infty/g, '∞')
        .replace(/\\cup/g, '∪')
        .replace(/\\cap/g, '∩')
        .replace(/\\in/g, '∈')
        .replace(/\\notin/g, '∉')
        .replace(/\\subset/g, '⊂')
        .replace(/\\supset/g, '⊃')
        .replace(/\\subseteq/g, '⊆')
        .replace(/\\supseteq/g, '⊇')
        .replace(/\\emptyset/g, '∅')
        .replace(/\\mathbb\{R\}/g, 'ℝ')
        .replace(/\\mathbb\{N\}/g, 'ℕ')
        .replace(/\\mathbb\{Z\}/g, 'ℤ')
        .replace(/\\mathbb\{Q\}/g, 'ℚ')
        .replace(/\\mathbb\{C\}/g, 'ℂ')
        .replace(/\\alpha/g, 'α')
        .replace(/\\beta/g, 'β')
        .replace(/\\gamma/g, 'γ')
        .replace(/\\delta/g, 'δ')
        .replace(/\\epsilon/g, 'ε')
        .replace(/\\theta/g, 'θ')
        .replace(/\\lambda/g, 'λ')
        .replace(/\\mu/g, 'μ')
        .replace(/\\pi/g, 'π')
        .replace(/\\sigma/g, 'σ')
        .replace(/\\tau/g, 'τ')
        .replace(/\\phi/g, 'φ')
        .replace(/\\omega/g, 'ω')
        // 处理分数（在特殊字符之后处理）
        .replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, '<span class="fraction"><sup>$1</sup>/<sub>$2</sub></span>')
        // 处理根号
        .replace(/\\sqrt\{([^}]+)\}/g, '√<span class="radicand">$1</span>')
        // 处理上标
        .replace(/\^(\d+)/g, '<sup>$1</sup>')
        .replace(/\^([a-zA-Z])/g, '<sup>$1</sup>')
        // 处理下标
        .replace(/_(\d+)/g, '<sub>$1</sub>')
        .replace(/_([a-zA-Z])/g, '<sub>$1</sub>')
        // 处理大括号（集合表示）
        .replace(/\\\{/g, '{')
        .replace(/\\\}/g, '}')
        // 处理分段函数
        .replace(/\\begin\{cases\}([^}]+)\\end\{cases\}/g, (match, content) => {
          const cases = content.split('\\\\').map(caseItem => {
            const parts = caseItem.split('&');
            if (parts.length === 2) {
              return `<div class="case-item">${parts[0].trim()} &nbsp;&nbsp; ${parts[1].trim()}</div>`;
            }
            return `<div class="case-item">${caseItem.trim()}</div>`;
          }).join('');
          return `<div class="cases">${cases}</div>`;
        })
        // 处理绝对值
        .replace(/\\left\|([^|]+)\\right\|/g, '|$1|')
        // 处理行内数学公式 \( ... \)（最后处理，避免影响其他规则）
        .replace(/\\\(([^)]+)\\\)/g, '<span class="math-inline">$1</span>')
        // 处理块级数学公式 \[ ... \]
        .replace(/\\\[([^\]]+)\\\]/g, '<div class="math-block">$1</div>')
        // 处理美元符号数学公式 $ ... $
        .replace(/\$([^$]+)\$/g, '<span class="math-inline">$1</span>')
        // 处理双美元符号数学公式 $$ ... $$
        .replace(/\$\$([^$]+)\$\$/g, '<div class="math-block">$1</div>')
        // 处理换行符
        .replace(/\\\\/g, '<br>')
        // 处理对齐符号
        .replace(/&/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
        // 处理空格
        .replace(/\\,/g, '&nbsp;')
        .replace(/\\;/g, '&nbsp;&nbsp;')
        .replace(/\\quad/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
        .replace(/\\qquad/g, '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');

      return rendered;
    }
  }
}
</script>

<style scoped>
.batch-student-upload {
  padding: 20px;
}

.info-section {
  margin-bottom: 20px;
}

.upload-section, .batch-upload-section, .folder-upload-section {
  margin-top: 20px;
}

.student-select, .image-upload, .batch-image-upload, .folder-upload, .zip-upload {
  margin-bottom: 20px;
}

.folder-upload-box {
  width: 100%;
  height: 180px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s;
}

.folder-upload-box:hover {
  border-color: #409EFF;
}

.folder-upload-box .el-icon-folder-opened {
  font-size: 64px;
  color: #c0c4cc;
  margin-bottom: 8px;
}

.folder-upload-box .upload-text {
  font-size: 16px;
  color: #606266;
}

.upload-type-selector {
  margin-bottom: 20px;
}

.selected-folder {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #f0f9eb;
  border-radius: 4px;
  border-left: 3px solid #67c23a;
}

.folder-preview {
  margin: 20px 0;
}

.folder-stats {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 8px 0;
  border-top: 1px solid #eee;
  color: #606266;
}

h4 {
  margin-bottom: 15px;
  color: #606266;
  font-size: 16px;
}

.upload-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.upload-history {
  margin-top: 40px;
}

.batch-info, .folder-info {
  margin-bottom: 20px;
}

.batch-preview {
  margin: 20px 0;
}

.image-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.preview-image {
  max-width: 100%;
  max-height: 500px;
}

.no-image {
  color: #909399;
  font-size: 14px;
}

.judge-result-container {
  padding: 10px 0;
}

.student-result {
  margin-bottom: 30px;
}

.student-result .el-divider {
  margin: 20px 0;
}

.no-result {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 20px;
}

/* 新增样式 */
.batch-manual-match {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.batch-match-tools {
  margin-top: 15px;
}

.match-by-pattern, .match-by-sequence {
  margin-top: 15px;
}

.match-form {
  margin-top: 10px;
}

.homework-info-display {
  margin-top: 15px;
}

.homework-alert {
  border-radius: 8px;
}

.homework-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.homework-header i {
  font-size: 20px;
  color: #409EFF;
  margin-right: 8px;
}

.homework-header h3 {
  margin: 0;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.homework-card {
  border-radius: 8px;
  border: none;
}

.homework-content {
  padding: 5px 0;
}

.homework-name, .homework-id {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.homework-name .label, .homework-id .label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  margin-right: 10px;
}

.homework-name .value {
  font-weight: 600;
  color: #303133;
  font-size: 16px;
}

.homework-id .el-tag {
  font-weight: 500;
}

/* 批改结果弹窗样式 */
.judge-result-container {
  padding: 10px 0;
}

.student-result {
  margin-bottom: 30px;
}

.student-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.student-info h3 {
  margin: 0;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
}

.overall-status .el-tag {
  font-size: 16px;
  padding: 8px 16px;
  border-radius: 20px;
}

.statistics {
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  transition: transform 0.2s;
}

.stat-item:hover {
  transform: translateY(-2px);
}

.stat-item.correct {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
}

.stat-item.error {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  color: #495057;
  margin-bottom: 5px;
}

.stat-item.correct .stat-number {
  color: #155724;
}

.stat-item.error .stat-number {
  color: #721c24;
}

.stat-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.questions-table {
  margin-top: 20px;
}

.question-content, .answer-content {
  line-height: 1.6;
  word-break: break-word;
}

.comment-content {
  line-height: 1.5;
  color: #606266;
  font-size: 13px;
}

/* 数学公式样式 */
.math-inline {
  font-family: 'Times New Roman', serif;
  font-style: italic;
  background: #f0f0f0;
  padding: 2px 4px;
  border-radius: 3px;
  margin: 0 2px;
  display: inline-block;
}

.math-block {
  font-family: 'Times New Roman', serif;
  text-align: center;
  margin: 10px 0;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 5px;
  border-left: 4px solid #007bff;
}

.fraction {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  margin: 0 2px;
}

.fraction sup {
  display: block;
  border-bottom: 1px solid #000;
  padding-bottom: 1px;
  font-size: 0.8em;
}

.fraction sub {
  display: block;
  padding-top: 1px;
  font-size: 0.8em;
}

.radicand {
  text-decoration: overline;
  padding: 0 2px;
}

.cases {
  text-align: left;
  margin: 5px 0;
  padding: 5px;
  background: #f8f9fa;
  border-radius: 3px;
  border: 1px solid #dee2e6;
}

.case-item {
  margin: 2px 0;
  padding: 2px 0;
}

/* 数学符号样式 */
sup {
  font-size: 0.7em;
  vertical-align: super;
  line-height: 0;
}

sub {
  font-size: 0.7em;
  vertical-align: sub;
  line-height: 0;
}

/* 集合符号样式 */
.question-content, .answer-content {
  font-family: 'Times New Roman', serif;
  line-height: 1.6;
  word-break: break-word;
}

.question-content .math-inline,
.answer-content .math-inline {
  font-family: 'Times New Roman', serif;
  font-style: italic;
  background: #e8f4fd;
  padding: 1px 3px;
  border-radius: 2px;
  margin: 0 1px;
  border: 1px solid #b3d9ff;
}

/* 表格行样式 */
.el-table .success-row {
  background-color: #f0f9ff;
}

.el-table .error-row {
  background-color: #fef2f2;
}

.el-table .success-row:hover > td {
  background-color: #e0f2fe !important;
}

.el-table .error-row:hover > td {
  background-color: #fce7e7 !important;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .student-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .statistics .el-col {
    margin-bottom: 10px;
  }

  .questions-table .el-table {
    font-size: 12px;
  }
}
</style>
